import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile, } from "../../../Services/ApiTestService/aadharTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { useService } from "../../../context/ServiceContext";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { FaCopy, FaIdBadge, FaUser } from "react-icons/fa";
import { dlVerifcationData, passportCardData, voterIdCardData } from "../data2";
import { verifyDlServiceV2, verifyPassportV2Service, verifyVoterIdService } from "../../../Services/ApiTestService/panTestService";

const DLVerficationV2 = () => {
    const [dlNumber, setdlNumber] = useState("");
    const [dob, setDob] = useState("");
    const { serviceName } = useService();
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [profileData, setProfileData] = useState({});
    const [dlDetails, setdlDetails] = useState(null);
    const [responseDetails, setReponseDetails] = useState(null);

    const handleSubmit = async () => {
        try {
            if (dlNumber === "") {
                errors.dlNumber = 'DL number is required.';
                return
            }

            if (dob === "") {
                errors.dlNumber = 'Dob is required.';
                return
            }
            const payload = {

                "api_id": profileData?.user_id,
                "api_key": profileData?.api_key,
                "token_id": profileData?.token_id,

                "dlNumber": dlNumber,
                'dob': dob

            }
            setIsLoading(true);
            setErrors({})
            let response = await verifyDlServiceV2(payload);
            //let response = dlVerifcationData;
            setIsLoading(false)
            if (response.status.code === 200) {

                setdlDetails(response.data);
                setReponseDetails(response)
                showSuccessToast(response.message || response.data.message || "DL Number  Verified successfully");

            } else {
                showErrorToast(response.message || response.data.message || response.status.message || "Failed to verify dl number ")
            }
        } catch (error) {
            setIsLoading(false);
            showErrorToast('Something went wrong')
        }
    }

    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }


    // Fetch Profile Data on Mount
    useEffect(() => {
        async function fetchProfileData() {
            try {
                setIsLoading(true);
                const response = await fetchProfile(); // API call to get profile details
                setProfileData(response.data);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching profile data", error);
                showErrorToast("Failed to fetch profile data.");
                setIsLoading(false);
            }
        }
        fetchProfileData();
    }, []);

const renderCompanyCard = () => {
    if (!dlDetails ) {
        return (
            <div className="text-center p-4 bg-red-100 border border-red-300 text-red-700 rounded">
                No driving license data available.
            </div>
        );
    }

    const renderObject = (obj) => {
        return Object.entries(obj).map(([key, value]) => (
            <div key={key} className="mb-2">
                <span className="font-bold capitalize">{key.replace(/_/g, ' ')}:</span>{" "}
                {typeof value === 'object' && value !== null
                    ? Array.isArray(value)
                        ? ""
                        : ""
                    : value || "N/A"}
            </div>
        ));
    };

    const renderArray = (arr) => {
        return arr.map((item, index) => (
            <div key={index} className="pl-4 mb-2 border-l-2 border-blue-200">
                {typeof item === 'object' ? renderObject(item) : <div className="flex">{item}</div>}
            </div>
        ));
    };

    return (
        <div className="relative bg-white/70 backdrop-blur-lg border border-blue-100 p-6 rounded-2xl shadow-xl max-w-4xl mx-auto">
            {/* Decorative Chip */}
            <div className="absolute top-4 right-4 w-10 h-6 bg-yellow-400 rounded-sm shadow-inner" />
            
            <div className="mb-4 flex items-center gap-2">
                <FaUser className="text-blue-600 text-xl" />
                <h2 className="text-2xl font-bold text-blue-900">
                    {dlDetails.details_of_driving_licence?.name || "Name Not Available"}
                </h2>
            </div>

            <div className="text-gray-700 text-sm space-y-4">
                {/* Direct DL fields */}
                <div>
                    <h3 className="font-semibold text-blue-700 mb-2">Basic Information</h3>
                    {renderObject({
                        dl_number: dlDetails.dl_number,
                        dob: dlDetails.dob,
                    })}
                </div>

              
                <div>
                    <h3 className="font-semibold text-blue-700 mb-2">Badge Details</h3>
                    {renderArray(dlDetails.badge_details || [])}
                </div>

            
                <div>
                    <h3 className="font-semibold text-blue-700 mb-2">DL Validity</h3>
                    {renderObject(dlDetails.dl_validity || {})}
                </div>

          
                <div>
                    <h3 className="font-semibold text-blue-700 mb-2">Driving Licence Details</h3>
                    {renderObject(dlDetails.details_of_driving_licence || {})}
                </div>

          
                {/* <div>
                    <h3 className="font-semibold text-blue-700 mb-2">Addresses</h3>
                    {renderArray(dlDetails.details_of_driving_licence?.address_list || [])}
                </div> */}
            </div>
        </div>
    );
};




    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }
    return (
        <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading={serviceName} />


            {/* Go Back Button */}
            <div className="w-full md:w-auto flex justify-end md:justify-end order-1">
                <Link
                    to="/TestMaster"
                    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-2 py-1 rounded-md font-semibold shadow-md transition duration-300"
                >
                    <span>Go Back</span>
                    <IoArrowBackCircleOutline size={24} />
                </Link>
            </div>
            <div className="flex flex-wrap gap-3 justify-start md:ml-64 ml-0">


                {/* Aadhar Number Input */}
                <div className="w-full md:w-1/6 order-2">
                    <InputWithLabel
                        type="text"
                        label="DL Number"
                        placeholder="Enter dl"

                        className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full uppercase"
                        name="dlNumber"
                        id="dlNumber"
                        required={true}
                        value={dlNumber}
                        onChange={(e) => setdlNumber(e.target.value)}
                        error={errors.dlNumber}
                    />

                </div>
                <div className="w-full md:w-1/6 order-2">
                    <InputWithLabel
                        type="date"
                        label="Date of birth"
                        placeholder="Enter Voter Id"
                        maxLength={12}
                        className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full uppercase"
                        name="dob"
                        id="dob"
                        required={true}
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        error={errors.dob}
                    />

                </div>


                <div className="w-full md:w-auto order-3">
                    <Button
                        type="button"
                        className="text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 hover:from-blue-900 hover:to-blue-400 border-4"
                        id="verifyPan"
                        name="verifyPan"
                        text="Verify Pan"
                        onClick={handleSubmit}
                    />
                </div>


            </div>
            {dlDetails && (
                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>{renderCompanyCard()}</div>
                    <div>
                        <h3 className="bg-green-200 text-xl font-bold my-2 rounded p-2">Api Response </h3>
                        <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                            <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={() => handleCopyText(responseDetails)} />
                            {JSON.stringify(responseDetails, null, 2)}
                        </pre>
                    </div>
                </div>
            )}



            <div class="max-w-3xl mx-auto p-1 md:p-1 bg-white rounded-3xl shadow-2xl mt-1 border border-gray-200 transition-transform duration-300 hover:scale-[1.01]">
                <h2 class="text-2xl font-extrabold text-center text-gray-900 mb-3 tracking-tight">
                    🔐 Driving Licence  Verification Steps
                </h2>

                <ol class="list-decimal text-gray-800 space-y-3 pl-6 relative">
                    <li class="relative group hover:pl-4 transition-all duration-300">
                        <span class="inline-block group-hover:text-blue-600 transition-colors duration-300">
                            Enter your <span class="font-medium text-gray-900"> Driving Licence Number</span> carefully.
                        </span>
                    </li>
                    <li class="relative group hover:pl-4 transition-all duration-300">
                        <span class="inline-block">
                            Click on <span class="font-semibold text-blue-600 underline underline-offset-2 group-hover:text-blue-800 transition-colors duration-300">“Submit ”</span> to verify your Driving Licence Number.
                        </span>
                    </li>



                </ol>

                <div class="mt-6 border-t border-gray-300 pt-1">
                    <h3 class="text-xl font-bold text-gray-900 mb-1 flex items-center gap-2">
                        📌 Important Notes
                        <span class="text-yellow-500 animate-pulse text-lg">⚠️</span>
                    </h3>
                    <ul class="list-disc text-gray-700 space-y-2 pl-6">
                        <li class="hover:text-blue-600 transition duration-300">
                            Ensure the correct Driving Licence Number .
                        </li>
                        <li class="hover:text-blue-600 transition duration-300">
                            Do not refresh the page during the verification process.
                        </li>

                    </ul>
                </div>
            </div>



        </>
    );
};

export default DLVerficationV2;  